import React from 'react';
import BaseTemplate from './BaseTemplate';

const FresherTemplate = ({ data }) => {
  return <BaseTemplate data={data} />;
};

export default FresherTemplate;
